import auth from './auth'
import certificates from './certificates'
import courses from './courses'
import inviteCourse from './inviteCourse'
import profile from './profile'

export default {
  auth,
  certificates,
  courses,
  inviteCourse,
  profile,
}
